import SkillStyle from "./SkillStyle";


const SkillsTech = () => {
    return (<>
        <SkillStyle>

            <div className="row mainBox">
                <p className="text-center heading">TECHNICAL <span className="color">TOOLBOX </span></p>
                <div className="leftbox col-lg-8">
                    <h5>FrontEnd </h5>
                    <div className="frontLang languageSection ">
                        <img src="https://img.shields.io/badge/HTML5-E34F26?logo=html5&logoColor=white&style=for-the-badge" height="30" alt="html5 logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/CSS3-1572B6?logo=css3&logoColor=white&style=for-the-badge" height="30" alt="css3 logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/JavaScript-F7DF1E?logo=javascript&logoColor=black&style=for-the-badge" height="30" alt="javascript logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Tailwind CSS-06B6D4?logo=tailwindcss&logoColor=black&style=for-the-badge" height="30" alt="tailwindcss logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/TypeScript-3178C6?logo=typescript&logoColor=white&style=for-the-badge" height="30" alt="typescript logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/React-61DAFB?logo=react&logoColor=black&style=for-the-badge" height="30" alt="react logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/MUI-007FFF?logo=mui&logoColor=white&style=for-the-badge" height="30" alt="materialui logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Bootstrap-7952B3?logo=bootstrap&logoColor=white&style=for-the-badge" height="30" alt="bootstrap logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/WordPress-21759B?logo=wordpress&logoColor=white&style=for-the-badge" height="30" alt="wordpress logo" />

                    </div>
                    <hr />
                    <h5>Backend</h5>
                    <div className="languageSection ">
                        <img src="https://img.shields.io/badge/Node.js-339933?logo=nodedotjs&logoColor=white&style=for-the-badge" height="30" alt="nodejs logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Express-000000?logo=express&logoColor=white&style=for-the-badge" height="30" alt="express logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Postman-FF6C37?logo=postman&logoColor=black&style=for-the-badge" height="30" alt="postman logo" />
                        <img width="5" alt="" />
                        <img src="https://skillicons.dev/icons?i=java" height="30" className="java" alt="java logo" />
                    </div>
                    <hr />

                    <h5>Database</h5>
                    <div className="languageSection ">
                        <img src="https://img.shields.io/badge/MongoDB-47A248?logo=mongodb&logoColor=white&style=for-the-badge" height="30" alt="mongodb" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/MySQL-4479A1?logo=mysql&logoColor=white&style=for-the-badge" height="30" alt="mysql" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Oracle-F80000?logo=oracle&logoColor=white&style=for-the-badge" height="30" alt="oracle" />
                    </div>
                </div>
                {/*----------------------------------------------  */}
                <div className="rightBox col-lg-4">

                    <div className="ToolBox">
                        <h5>Tools & Software</h5>
                        <img src="https://img.shields.io/badge/Adobe Photoshop-31A8FF?logo=adobephotoshop&logoColor=black&style=for-the-badge" height="30" alt="photoshop logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Adobe Illustrator-FF9A00?logo=adobeillustrator&logoColor=black&style=for-the-badge" height="30" alt="illustrator logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Figma-F24E1E?logo=figma&logoColor=white&style=for-the-badge" height="30" alt="figma logo" />
                        <img src="https://img.shields.io/badge/Git-F05032?logo=git&logoColor=white&style=for-the-badge" height="30" alt="git logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Linux-FCC624?logo=linux&logoColor=black&style=for-the-badge" height="30" alt="linux logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/GitHub-181717?logo=github&logoColor=white&style=for-the-badge" height="30" alt="github logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Visual Studio Code-007ACC?logo=visualstudiocode&logoColor=white&style=for-the-badge" height="30" alt="vscode logo" />
                        <img width="5" alt="" />
                        <img src="https://img.shields.io/badge/Eclipse IDE-2C2255?logo=eclipseide&logoColor=white&style=for-the-badge" height="30" alt="eclipseide logo" />
                    </div>

                </div>


            </div>
        </SkillStyle>
    </>)
}
export default SkillsTech;
